/**
 * Central Application Configuration
 * All environment-configurable domains and endpoints should be registered here.
 */

export const APP_CONFIG = {
  /**
   * Domain to redirect users for downloads and mobile app acquisition.
   */
  downloadRedirectUrl:
    import.meta.env.VITE_DOWNLOAD_REDIRECT_URL || "https://music.yours4u.com",

  /**
   * Base API endpoint.
   */
  apiBaseUrl: (
    import.meta.env.VITE_API_BASE_URL || "https://api.yours4u.com"
  ).replace(/\/$/, ""),

  /**
   * Base sharing service endpoint.
   */
  shareBaseUrl:
    import.meta.env.VITE_SHARE_BASE_URL || "https://ss.yours4u.com",

  /**
   * Google Analytics 4 Measurement ID (e.g. G-XXXXXXXXXX)
   */
  gaMeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || "",
} as const;

/**
 * Opens the configured music/app download domain in a new tab (_blank) by default.
 */
export function redirectToDownload(target: "_blank" | "_self" = "_blank"): void {
  if (target === "_blank") {
    window.open(APP_CONFIG.downloadRedirectUrl, "_blank", "noopener,noreferrer");
  } else {
    window.location.href = APP_CONFIG.downloadRedirectUrl;
  }
}
